import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import './MarketsPage.css';

export default function MarketsLayout() {
  return (
    <div className="markets-page">
      <nav className="markets-subnav" aria-label="Markets sections">
        <NavLink
          to="/markets/summary"
          className={({ isActive }) =>
            `markets-subnav-link${isActive ? ' markets-subnav-link--active' : ''}`
          }
        >
          Summary
        </NavLink>
        <NavLink
          to="/markets/models"
          className={({ isActive }) =>
            `markets-subnav-link${isActive ? ' markets-subnav-link--active' : ''}`
          }
        >
          Sleeper models
        </NavLink>
        <NavLink to="/markets/nba-distributions" className="markets-subnav-link">NBA distributions</NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
